import { createBrowserRouter, RouteObject } from 'react-router-dom';
import Error404 from 'pages/error/Error404';
import App from 'App';
import AuthRoutes from './AuthRoutes';
import Error500 from '../pages/error/Error500';
import { lazy, Suspense } from 'react';
import PhoenixLoader from '../components/common/PhoenixLoader';
import PublicRoutes from './PublicRoutes';
import PreIntakeRoutes from './PreIntakeRoutes';
import CaseRoutes from './CaseRoutes';
import UserManagementRoutes from './UserManagementRoutes';
import MainLayoutProvider from '../providers/MainLayoutProvider';
import AuthGuard from '../utils/route-guard/AuthGuard';
import MainLayout from '../layouts/MainLayout';
import Error403 from '../pages/error/Error403';
import SettingsRoutes from './SettingsRoutes';
import MdmRoutes from './MdmRoutes';
import IssueRoutes from './IssueRoutes';

const Profile = lazy(() => import('pages/profile'));
const Dashboard = lazy(() => import('pages/dashboard'));
const ServiceProviders = lazy(() => import('pages/service-providers'));
const Translation = lazy(() => import('pages/translation'));
const TermAndAgreement = lazy(() => import('pages/term-and-agreement'));

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      PublicRoutes,
      AuthRoutes,
      PreIntakeRoutes,
      CaseRoutes,
      MdmRoutes,
      UserManagementRoutes,
      SettingsRoutes,
      IssueRoutes,

      {
        path: '/',
        element: (
          <MainLayoutProvider>
            <AuthGuard>
              <MainLayout />
            </AuthGuard>
          </MainLayoutProvider>
        ),
        children: [
          {
            path: '/dashboard',
            element: (
              <Suspense fallback={<PhoenixLoader />}>
                <Dashboard />
              </Suspense>
            )
          },
          {
            path: '/service-providers',
            element: (
              <Suspense fallback={<PhoenixLoader />}>
                <ServiceProviders />
              </Suspense>
            )
          },
          {
            path: '/translation',
            element: (
              <Suspense fallback={<PhoenixLoader />}>
                <Translation />
              </Suspense>
            )
          },
          {
            path: '/profile',
            element: (
              <Suspense fallback={<PhoenixLoader />}>
                <Profile />
              </Suspense>
            )
          },
          {
            path: '/term-and-agreement',
            element: (
              <Suspense fallback={<PhoenixLoader />}>
                <TermAndAgreement />
              </Suspense>
            )
          }
        ]
      },
      {
        path: '*',
        element: <Error404 />
      },
      {
        path: '/error/server-error',
        element: <Error500 />
      },
      {
        path: '/error/403',
        element: <Error403 />
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
